// extracted by mini-css-extract-plugin
export default {"close-icon":"drawer_close-icon__y3Ktc"};